import { useSelector } from 'react-redux';
import { CompanyDetailsInterface } from '../../services/exports/Interfaces';
import { selectCompany } from '../../store/slices/InitialDataSlice';

export enum SessionStorageReservedKey {
  OrderMethodInfoStatus = 'order_method_info_status',
  AllergensCardTipSeen = 'allergens_card_tip_seen',
  AllergensModalTipSeen = 'allergens_modal_tip_seen',
  AllergensModalConfirmed = 'allergens_modal_confirmed',
}

export default function useSessionStorage(customCompany?: CompanyDetailsInterface) {
  const defaultCompany = useSelector(selectCompany);
  const company = customCompany ?? defaultCompany;

  const composeKey = (key: SessionStorageReservedKey) => `company-${company?.id}-${key}`;

  const getItem = (key: SessionStorageReservedKey, defaultValue?: any): null | string =>
    sessionStorage.getItem(composeKey(key)) ?? defaultValue;
  const setItem = (key: SessionStorageReservedKey, value: any) => sessionStorage.setItem(composeKey(key), value);

  return {
    getItem,
    setItem,
  };
}
